import { toast } from 'react-toastify'
import { printLog } from './printLog'
import { isPlainObject } from 'lodash-es'
import AxiosCustomError from './AxiosCustomError'
import { UserStore } from 'store/UserStore'
import { AuthStore } from 'store/AuthStore'

const interceptors = (axios, api) => {
  const { response, request } = axios.interceptors

  request.use(async (config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    return config
  })

  response.use((response) => {
    if (!isPlainObject(response.data)) {
      return Promise.reject(new AxiosCustomError(response))
    }

    if (response.data.errors?.length) {
      const { message, code } = response.data.errors[0]

      return Promise.reject(new AxiosCustomError(response, message, code))
    }

    printLog(response)
    return response.data
  })

  response.use(undefined, async (error) => {
    const originalRequest = { ...error.config }
    originalRequest._isRetry = true
    const isRetry = originalRequest._isRetry

    if (error.response?.status === 401 && Boolean(error.config) && !isRetry) {
      try {
        const res = api.auth.refreshToken()
        localStorage.setItem('token', res.data)
        UserStore.updateUserData()
        return await axios.request(originalRequest)
      } catch (e) {
        AuthStore.isUserAuthenticated = false
        if (localStorage.getItem('token')) {
          toast.error('Сессия истекла. Пожалуйста, авторизуйтесь')
          localStorage.removeItem('token')
          UserStore.clearUserData()
        }
        console.error(e)
      }
    }

    throw error
  })
}

export default interceptors
